var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.24902C11 1.21647 10.994 1.18473 10.982 1.15381C10.97 1.12288 10.9503 1.09603 10.9229 1.07324C10.8715 1.02441 10.8099 1 10.7379 1C10.666 1 10.6043 1.02441 10.5529 1.07324L6 5.39453L1.45221 1.07324C1.40082 1.02441 1.3383 1 1.26465 1C1.19099 1 1.12847 1.02441 1.07708 1.07324C1.02569 1.12207 1 1.18066 1 1.24902C1 1.31738 1.02569 1.37598 1.07708 1.4248L5.81501 5.92676C5.86639 5.97559 5.92806 6 6 6C6.07194 6 6.13361 5.97559 6.18499 5.92676L10.9229 1.4248C10.9503 1.40202 10.97 1.37516 10.982 1.34424C10.994 1.31331 11 1.28158 11 1.24902Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.3040149c367258d9d803783bfcfbc491.svg";
export { ForwardRef as ReactComponent };